import { API } from 'aws-amplify';
import { requestWrapper } from '../../services/api/VIRSApiService';

const API_NAME = 'VirsApiProxy';

function get(path) {
  return requestWrapper((options) => API.get(API_NAME, `/${path}`, options));
}

function post(path, body) {
  return requestWrapper((options) => {
    // set the body
    Object.assign(options, { body });
    // make request
    return API.post(API_NAME, `/${path}`, options);
  });
}

function patch(path, body) {
  return requestWrapper((options) => {
    // set the body
    Object.assign(options, { body });
    // make request
    return API.patch(API_NAME, `/${path}`, options);
  });
}

function del(path) {
  return requestWrapper((options) => API.del(API_NAME, `/${path}`, options));
}

// GDPS-1483 - delete - we cannot use work "delete"
// since it is a keyword
function deleteVendorItem(path) {
  return del(path);
}

export { get, post, patch, deleteVendorItem };
